import {VendorInvoices} from './endpoints';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class VendorInvoiceService extends BaseService {
    constructor(http: HttpClient) {
        super(http);
    }

    delete(id: any): Observable<any> {
        const url = VendorInvoices + "/" + id;
        const options = {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*'
            }
        };
        return this.deleteRequest(url, options);
    }

    deleteAttachment(id: any, attachmentId: any): Observable<any> {
        const url = VendorInvoices + "/" + id + "?AttachmentID=" + attachmentId;
        const options = {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*'
            }
        };
        return this.deleteRequest(url, options);
    }

    getItems(VendorInvoicesParams: any): Observable<any> {
        const url = VendorInvoices + '?' + this.makeQueryString(VendorInvoicesParams);
        return this.getRequest(url, null);
    }

    getVendorInvoiceById(VendorInvoicesId: any): Observable<any> {
        const url = VendorInvoices + '/' + VendorInvoicesId;       
        return this.getRequest(url, null);
    }

    update(VendorInvoicesId: number, updateParams: any): Observable<any> {
        const url = VendorInvoices + '/' + VendorInvoicesId;
        const options = {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*'
            }
        };
        return this.putRequest(url, updateParams, options);
    }

    save(data){
        const url = VendorInvoices;        

        const options = {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*'
            }
        };
        return  this.postRequest(url,data,options);
    }
}
